import axios from 'axios';

import { getI18nextInstance } from 'i18n';
import { API_ENDPOINTS } from 'utils/constants';
import { SSOProvider } from 'utils/types';

function getDifferenceBetweenDatesInMinutes(date1: Date, date2: Date): number {
  return Math.floor(Math.abs(date1.getTime() - date2.getTime()) / (60 * 1000));
}

export function getRemainingTime(date: string): string {
  const i18n = getI18nextInstance();
  const differenceInMinutes = getDifferenceBetweenDatesInMinutes(
    new Date(date),
    new Date()
  );
  let days = 0;
  let hours = 0;
  let minutes = 0;
  [days, hours] = [
    Math.floor(differenceInMinutes / (24 * 60)),
    differenceInMinutes % (24 * 60)
  ];
  [hours, minutes] = [Math.floor(hours / 60), hours % 60];
  const result = [];

  if (days) {
    result.push(i18n.t('date.day', { count: days }));
  }

  if (hours) {
    result.push(i18n.t('date.hour', { count: hours }));
  }

  if (minutes) {
    result.push(i18n.t('date.minute', { count: minutes }));
  }

  return result.length ? result.join(' ') : '';
}

export const getEmailSSOProvider = async (
  email: string
): Promise<SSOProvider | null> =>
  axios
    .get<SSOProvider>(API_ENDPOINTS.SSO_PROVIDERS, {
      params: { q: email }
    })
    .then((response) => response.data)
    .catch(() => null);
